import {Injectable} from "@angular/core";
import {WebService} from "./api/web.service";
import {ServiceUrlConstants} from "../constants/service-url-constants";
import {AdhocProcessExpensesRequest} from "../models/api.model";
import {map} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AdhocService {
  constructor(private webservice: WebService) {
  }
  callAdhocBankingInfoAPI() {
    return this.webservice.post(ServiceUrlConstants.API_ADHOC_BANKING_INFO_LOAD, {})
  }

  callAdhocProcessExpensesAPI(request: AdhocProcessExpensesRequest, file: File) {
    const formData: FormData = new FormData();
    const requestData = new Blob([JSON.stringify(request)], { type: 'application/json' })
    formData.append('request', requestData)

    if (file) {
      formData.append('report', file)
    }

    return this.webservice.post(ServiceUrlConstants.API_ADHOC_PROCESS_EXPENSES, formData, null, [], false).pipe(map((data :any) => data))
  }
}
